import React from "react";
import { Container, Card, CardImage, BasicDetails, CardTitle, Price, IconContainer, Icon, DetailContainer, DetailText, ButtonContainer,InputButtonContainer, Button, Input, ReportLink, MoreInfo } from "./styles/tableCards";


export default function TableCards({children,...props}){
    return <Container {...props}>{children}</Container>
}

TableCards.Card = function TableCardsCard({children,...props}){
    return <Card {...props}>{children}</Card>
}

TableCards.CardImage = function TableCardsCardImage({children,...props}){
    return <CardImage {...props}>{children}</CardImage>
}

TableCards.BasicDetails = function TableCardsBasicDetails({children, ...props}){
    return <BasicDetails {...props}>{children}</BasicDetails>
}

TableCards.CardTitle = function TableCardsCardTitle({children, ...props}){
    return <CardTitle {...props}>{children}</CardTitle>
}

TableCards.Price = function TableCardsPrice({children, ...props}){
    return <Price {...props}>{children}</Price>
}

TableCards.IconContainer = function TableCardsIconContainer({children, ...props}){
    return <IconContainer {...props}>{children}</IconContainer>
}

TableCards.Icon = function TableCardsIconContainer({...props}){
    return <Icon {...props} />
}

TableCards.DetailContainer = function TableCardsDetailContainer({children, ...props}){
    return <DetailContainer {...props}>{children}</DetailContainer>
}

TableCards.DetailText = function TableCardsDetailText({children, ...props}){
    return <DetailText {...props}>{children}</DetailText>
}

TableCards.ButtonContainer = function TableCardsButtonContainer({children, ...props}){
    return <ButtonContainer {...props}>{children}</ButtonContainer>
}

TableCards.InputButtonContainer = function TableCardsInputButtonContainer({children, ...props}){
    return <InputButtonContainer {...props}>{children}</InputButtonContainer>
}

TableCards.Input = function TableCardsInput({...props}){
    return <Input {...props} />
}

TableCards.Button = function TableCardsButton({children, ...props}){
    return <Button {...props}>{children}</Button>
}

TableCards.ReportLink = function TableCardsReportLink({children, ...props}){
    return <ReportLink {...props}>{children}</ReportLink>
}

TableCards.MoreInfo = function TableCardsMoreInfo({children, ...props}){
    return <MoreInfo {...props}>{children}</MoreInfo>
}